import axios from "axios";
import { toast } from "react-toastify";
import { passwordActions } from "../slices/passwordSlice";


// Forget Password
export function forgotPasswordApi(email){
  return async (dispatch) => {
     try {

      const { data } = await axios.post(
        "https://remote-attendance.hsagroup.info/api/password/reset-password-link",
        { email }
      );

      toast.success(data.message);

      return data; // 🔥 important

     } catch (error) {

      toast.error(
        error.response?.data?.message || "Something went wrong"
      );

      throw error; // 🔥 important
     } 
  }
}



// Forget Password
export function getResetPasswordApi(userId,token){
    return async(dispatch ) => {
       try {

         await axios.get(`https://remote-attendance.hsagroup.info/api/password/reset-password/${userId}/${token}`)
         
 

       } catch (error) {
        dispatch(passwordActions.setError());


       } 
    }
}



// Reset Password
export function ResetPasswordApi(newPassword, user, navigate){
    return async (dispatch) => {
       try {

         const { data } = await axios.post(
           `https://remote-attendance.hsagroup.info/api/password/reset-password/${user.userId}/${user.token}`,
           { password: newPassword }
         );

         toast.success(data.message);

         navigate("/login");

       } catch (error) {
         toast.error(error.response?.data?.message || "Something went wrong");
       } 
    }
}

